/**
 * Item images at the size they are drawn. Item photos come from vendors at full size (TCGplayer's
 * are 736×1024, about 225 KB); a row of small cards needs a fraction of that. A host that serves
 * sizes is asked for one; any other URL is returned as it is.
 */

/** TCGplayer's product image CDN, which serves `fit-in/{w}x{h}/` sizes of the same file. */
const TCGPLAYER_IMAGE = /^https:\/\/product-images\.tcgplayer\.com\/([^/?#]+)$/;

/** Card art's height for its width (63:88), so a fit-in box never limits the width. */
const CARD_HEIGHT = 88 / 63;

/**
 * `src` at most `width` pixels wide, where its host serves sizes, else `src`. Widths are rounded up
 * to a step of 40, so nearby sizes share one cached file.
 */
export function sizeItemImage(src: string, width: number): string {
  const tcgplayer = TCGPLAYER_IMAGE.exec(src);
  if (!tcgplayer) return src;
  const w = Math.max(40, Math.ceil(width / 40) * 40);
  return `https://product-images.tcgplayer.com/fit-in/${w}x${Math.ceil(w * CARD_HEIGHT)}/${tcgplayer[1]}`;
}
